import {
  NotificationChannelEnum, // eslint-disable-line no-unused-vars
  NotificationDataResponse, // eslint-disable-line no-unused-vars
  NotificationsApi,
  NotificationVehicleActiveUpdateRequest, // eslint-disable-line no-unused-vars
  NotificationVehicleUpdateRequest, // eslint-disable-line no-unused-vars
} from '@clients/myTrips'
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/my-trips'

export default class ExtendedNotificationsApi extends NotificationsApi {
  getVehicleNotifications (vehicleId: number, options?: any): AxiosPromise<NotificationDataResponse> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getVehicleNotifications(vehicleId, undefined, optionsParam)
  }

  changeVehicleNotifications (vehicleId: number, requestBody: NotificationVehicleUpdateRequest, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.changeVehicleNotifications(vehicleId, requestBody, undefined, optionsParam)
  }

  changeVehicleNotificationActive (vehicleId: number, requestBody: NotificationVehicleActiveUpdateRequest, options?: any): AxiosPromise<void> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.changeVehicleNotificationActive(vehicleId, requestBody, undefined, optionsParam)
  }

  getAvailableNotificationChannels (options?: any): AxiosPromise<Array<NotificationChannelEnum>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getAvailableNotificationChannels(undefined, optionsParam)
  }
}
